<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.total_bp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Data da última avaliação de diabetes e percentual da(s) boa(s) prática(s) aplicável(is) realizada(s) na pessoa."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.total_bp="{ item }">
            {{
              item.ult_aval_diab != null ? formatDate(item.ult_aval_diab) : ''
            }}
            <br />
            <span>({{ item.total_bp ?? 0 }}%)</span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Auto referido</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <!-- <th v-if="exibirCopilot">Suporte</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.auto_referido == 1 ? 'Sim' : 'Não' }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <!-- <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td> -->
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-boas-praticas">
                <thead>
                  <tr>
                    <th>
                      Consultas
                      <span
                        v-b-tooltip.hover.right
                        title="(A) Ter pelo menos 01 (uma) consulta presencial ou remota realizadas por médica(o) ou enfermeira(o), nos últimos 06 (seis) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Aferição PA
                      <span
                        v-b-tooltip.hover.right
                        title="(B) Ter pelo menos 01 (um) registro de aferição de pressão arterial realizado nos últimos 06 (seis) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Visitas
                      <span
                        v-b-tooltip.hover.right
                        title="(D) Ter pelo menos 02 (duas) visitas domiciliares realizadas por ACS/TACS, com intervalo mínimo de 30 (trinta) dias, nos últimos 12 (doze) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Peso e altura
                      <span
                        v-b-tooltip.hover.right
                        title="(C) Ter pelo menos 01 (um) registro simultâneos de peso e altura realizado nos últimos 12 (doze) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Hemoglobina
                      <span
                        v-b-tooltip.hover.right
                        title="(E) Ter pelo menos 01 (um) registro de solicitação de hemoglobina glicada realizada ou avaliada, nos últimos 12 (doze) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Avaliação pés
                      <span
                        v-b-tooltip.hover.right
                        title="(F) Ter pelo menos 01 (uma) avaliação dos pés realizada nos últimos 12 (doze) meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.a_pb == null || item.a_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('consultas', item)"
                      >
                        {{ item.a_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.b_pb == null || item.b_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('afericao-pa', item)"
                      >
                        {{ item.b_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-if="item.tp_ine_fci != '76'">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.c_pb == null || item.c_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('visitas', item)"
                      >
                        {{ item.c_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.d_pb == null || item.d_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('peso-altura', item)"
                      >
                        {{ item.d_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.e_pb == null || item.e_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('hemoglobina-glicada', item)"
                      >
                        {{ item.e_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.f_pb == null || item.f_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('avaliacao-pes', item)"
                      >
                        {{ item.f_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="item.a_pb == null || item.a_pb == 0"
                variant="danger"
                show
              >
                Pessoa sem avaliação de diabetes em consulta médica ou de
                enfermagem entre {{ dtUltimoRegistroIdSinc(49) }} e
                {{ dtUltimoRegistroIdSinc(43) }}. Últimos 6 meses contados a
                partir do final do quadrimestre atual para trás.
              </b-alert>

              <b-alert
                v-if="item.b_pb == null || item.b_pb == 0"
                variant="danger"
                show
              >
                Pessoa ainda não tem pelo menos 01 registro de aferição da
                pressão arterial, realizado nos últimos 6 meses.
              </b-alert>

              <b-alert
                v-if="item.c_pb == null || item.c_pb == 0"
                variant="danger"
                show
              >
                Pessoa ainda não tem pelo menos 02 visitas domiciliares por
                ACS/Tacs, com intervalo mínimo de 30 dias, realizadas nos
                últimos 12 meses.
              </b-alert>

              <b-alert
                v-if="item.d_pb == null || item.d_pb == 0"
                variant="danger"
                show
                >Pessoa ainda não tem realizado pelo menos 01 (um) registro de
                peso e altura, nos últimos 12 meses.
              </b-alert>

              <b-alert
                v-if="item.e_pb == null || item.e_pb == 0"
                variant="danger"
                show
                >Pessoa ainda não tem pelo menos 01 registro de hemoglobina
                glicada, solicitada ou avaliada, nos últimos 12 meses.
              </b-alert>

              <b-alert
                v-if="item.f_pb == null || item.f_pb == 0"
                variant="danger"
                show
                >Pessoa ainda não tem pelo menos 01 registro de avaliação dos
                pés, realizado nos últimos 12 meses.
              </b-alert>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-pessoa-diabetes"
        ref="modal"
        title=""
        v-model="modal.show"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> {{ modal.title }}</template>
        <div class="modal-pessoa-diabetes-body" v-if="modal.item != null">
          <table
            class="table table-interna"
            v-if="modal.table.headers.length > 0"
          >
            <thead>
              <tr>
                <th
                  v-for="(itemHeader, indexHeader) in modal.table.headers"
                  :key="indexHeader"
                >
                  {{ itemHeader.label }}
                  <span
                    v-if="itemHeader.icon.show == true"
                    v-b-tooltip.hover.top
                    :title="itemHeader.icon.text"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <!-- Consultas -->
            <tbody v-if="modal.tipo == 'consultas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fai)"
                :key="index"
                :class="
                  Number(item.dias_decorridos) < 183 && item.aval_diabetico == 1
                    ? 'green'
                    : 'red'
                "
              >
                <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{
                    item.aval_diabetico == 1
                      ? 'Diabetes'
                      : 'Profissional não registrou avaliação de diabetes neste atendimento'
                  }}
                </td>
                <td>
                  {{ Math.floor(Number(item.dias_decorridos) / 30) }}
                  {{
                    Math.floor(Number(item.dias_decorridos) / 30) == 1
                      ? 'mês'
                      : 'meses'
                  }}
                </td>
              </tr>
            </tbody>
            <!-- Aferição PA -->
            <tbody v-if="modal.tipo == 'afericao-pa'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.afericao_pa)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.sistolica ?? '' }}
                </td>
                <td>
                  {{ item.diastolica ?? '' }}
                </td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-if="item.nu_cbo != null"
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.mi ?? '' }}
                </td>
              </tr>
            </tbody>
            <!-- Visitas -->
            <tbody v-if="modal.tipo == 'visitas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fvdt)"
                :key="index"
                :class="
                  item.dias_entre_visitas != null &&
                  item.dias_entre_visitas <= 30
                    ? 'green'
                    : ''
                "
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_visita) ?? '' }}</td>
                <td>{{ item.motivo_acomp }}</td>
                <td>
                  {{ item.desfecho ?? '' }}
                </td>
                <td>
                  <div v-if="item.dias_entre_visitas != null">
                    {{ item.dias_entre_visitas }}
                    {{ item.dias_entre_visitas == 1 ? 'dia' : 'dias' }}
                    ou
                    {{ Math.floor(Number(item.dias_entre_visitas) / 30) }}
                    {{
                      Math.floor(Number(item.dias_entre_visitas) / 30) == 1
                        ? 'mês'
                        : 'meses'
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
            <!-- Peso e altura -->
            <tbody v-if="modal.tipo == 'peso-altura'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.peso_altura)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.peso ?? '' }}
                </td>
                <td>
                  {{ item.altura ?? '' }}
                </td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-if="item.nu_cbo != null"
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.mi ?? '' }}
                </td>
              </tr>
            </tbody>
            <!-- Hemoglobina glicada -->
            <tbody v-if="modal.tipo == 'hemoglobina-glicada'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.hemoglobina)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.co_proced_aval ?? '' }}
                  <span
                    v-if="item.co_proced_aval != null"
                    v-b-tooltip.hover.top
                    :title="item.ds_proced_aval"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.co_proced_sol ?? '' }}
                  <span
                    v-if="item.co_proced_sol != null"
                    v-b-tooltip.hover.top
                    :title="item.ds_proced_sol"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
              </tr>
            </tbody>
            <!-- Avaliação pés -->
            <tbody v-if="modal.tipo == 'avaliacao-pes'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.aval_pes)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.co_proced ?? '' }}
                  <span
                    v-if="item.ds_proced != null"
                    v-b-tooltip.hover.top
                    :title="item.ds_proced"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-if="item.no_cbo != null"
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'Acompanhado',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'total_bp',
          width: '200px',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modal: {
        title: '',
        tipo: null,
        show: false,
        item: null,
        table: {
          headers: [],
        },
      },
      modalVacinas: {
        show: false,
        form: {
          dataAplicacao: null,
          lote: null,
          btn: {
            disabled: false,
            loading: false,
          },
        },
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
        return true
      }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${item.rowColor}`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    dtUltimoRegistroIdSinc(idSinc) {
      const registro =
        this.$store.getters.getUltimoRegistroTabelaSincronizadaPorIndicador(
          idSinc
        )

      if (!registro?.dt_ultimo_registro) return ''

      return registro.dt_ultimo_registro.split('-').reverse().join('/')
    },

    openModal(tipo, item) {
      this.modal.show = true
      this.modal.item = item
      this.modal.tipo = tipo
      switch (tipo) {
        case 'consultas':
          this.modal.title = 'Consultas'
          this.modal.table.headers = [
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Meses decorridos da data do atendimento até o final do quadrimestre avaliado',
              },
            },
          ]
          break
        case 'afericao-pa':
          this.modal.title = 'Aferição PA'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Sistólica',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Diastólica',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'visitas':
          this.modal.title = 'Visitas'
          this.modal.table.headers = [
            {
              label: 'Nº',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Visita',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Desfecho',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Dias decorridos entre a visita anterior e esta.',
              },
            },
          ]
          break
        case 'peso-altura':
          this.modal.title = 'Peso e altura'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Peso',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Altura',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'hemoglobina-glicada':
          this.modal.title = 'Hemoglobina glicada'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Exame avaliado',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Exame solicitado',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'avaliacao-pes':
          this.modal.title = 'Avaliação pés'
          this.modal.table.headers = [
            {
              label: 'Data',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Procedimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        default:
          break
      }
    },
  },
}
</script>

<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}

.table-boas-praticas {
  .table-boas-praticas-item {
    cursor: pointer;
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    text-align: center;
  }
}

.modal-pessoa-diabetes-body {
  .doses-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    gap: 20px;
    margin: 20px 0;
    background-color: #f1f0f5;
    padding: 15px;
    h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .doses-list-item {
      cursor: pointer;
      background-color: #fff;
      min-width: 120px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ccc;
      color: #000;
      border-radius: 6px;
      &.red {
        background: #ffb3b3 !important;
        // border-color: #990000 !important;
      }
      &.green {
        background: #b3ffb3;
        // border-color: #008000 !important;
      }
      &.white {
        background: #fff;
        // border-color: #000 !important;
      }
    }
  }
}
</style>
